import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/app/Services/loader.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {

  faqs:any;
  selectedFaq:any;

  constructor(private loader: LoaderService,
    private route: ActivatedRoute
    ) { }

    ngOnInit() {

      setTimeout(() => {
        this.loader.hideLoader();
      }, 300);
  
      this.faqs = this.route.snapshot.data.data.result; 
    }

}
